<script>
    import broker from '../../utils/broker'

    import BeritaSidebar from '@/components/sections/berita-sidebar';
    import BeritaPost from '@/components/sections/berita-post-full';
    export default {
        props : ['meta'],
        components: {
            BeritaSidebar,
            BeritaPost
        },
        data () {
            return {
                page : 1,
                limit : 10,
                news : [],
                currentPage :0,
                lastPage : 0,
                paging : []
            }
        },
        mounted(){
           this.getData(1)
        },
        methods : {
            getData(page){
                broker.fetch.get(`/webschool/content?page=${page}&limit=${this.limit}&types[]=information&status=published`)
                .then(res => {
                    const data = res.data.data
                    const meta = res.data.meta
                    this.news = data
                    this.currentPage = meta.current_page
                    this.lastPage = meta.last_page
                    this.pageNumbers()

                });
            },
            goPage(type){
                let number = 0;
                if (type === "next") {
                    number = this.currentPage + 1
                } else {
                    number = this.currentPage - 1
                }

                broker.fetch.get(`/webschool/content?page=${number}&limit=${this.limit}&types[]=information&status=published`)
                .then(res => {
                    const data = res.data.data
                    const meta = res.data.meta
                    this.news = data
                    this.currentPage = meta.current_page
                    this.lastPage = meta.last_page
                    this.pageNumbers()

                });
            },
            pageNumbers() {
                var result = [];
                if (this.lastPage - this.currentPage <= 2) {
                // if (this.currentPage > this.lastPage - this.limit) {
                    // result.push(this.lastPage - 2, this.lastPage - 1, this.lastPage);
                    if (this.lastPage -2 > 0)
                        result.push(this.lastPage - 2)
                    
                    if (this.lastPage -1 > 0)
                        result.push(this.lastPage - 1)

                    if (this.lastPage)
                        result.push(this.lastPage)

                } else {
                    result.push(this.currentPage, this.currentPage + 1, this.currentPage + 2, '...', this.lastPage);
                }
                 
                this.paging = result;
            },
            test(){
                console.log("test")
            }
        },
    };
</script>
<template>
    <div class="page-wrapper section-space--inner--60">
        <div class="blog-section">
            <div class="container">
                <div class="row mb-5">
                    <div class="col-sm-12 text-center">
                        <h3 class="text-color-orange font-size-24">Pengumuman</h3>
                        <h2>Pengumuman {{ this.meta.name }}</h2>
                        <p class="font-size-15">Pengumuman {{ this.meta.name }} dari berbagai macam kegiatan dan info terkini </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12" v-for="blog in news" :key="blog.id">
                        <BeritaPost :berita="blog" textColor="text-color-orange" />
                    </div>
                </div>
                <div class="row ">
                    <div class="col">
                        <ul class="page-pagination-orange section-space--top--30">
                            <li :class="[(currentPage === 1) ? 'btn-disabled' : '']"><a @click="goPage('prev')"><i class="fa fa-angle-left"></i> Sebelumnya</a></li>

                                <li v-for="page in paging"
                                :key="page" :class="[(currentPage === page || page === '...') ? 'active btn-disabled' : '']"><a @click="getData(page)">{{page}}</a>
                            </li>
                            <!--
                            <li class="active"><a href="#">01</a></li>
                            <li><a href="#">02</a></li>
                            <li><a href="#">03</a></li>
                            -->
                            <li  :class="[(currentPage === lastPage) ? 'btn-disabled' : '']"><a @click="goPage('next')"><i class="fa fa-angle-right"></i> Selanjutnya</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

